const SNAPSHOT_MODES = ["snapshot", "compact"];

export default SNAPSHOT_MODES;
